import React, { useEffect, useRef } from 'react'
import { InputGroup, InputGroupText } from 'reactstrap'
import { InputGroupAddon } from '@src/components/reactstrap-compat'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { XIcon, CalendarCheckIcon } from '@csrc/assets/icons'
import Proptypes from 'prop-types'
import classnames from "classnames"
import moment from 'moment'
//************************************//
import { trans, isRtl } from '@utils' //toLocalDateFormat
//************************************//
import 'bootstrap-daterangepicker/daterangepicker.css'
import '@src/assets/scss/daterangepicker.scss'
import { LongDateFormatKey } from "@node_modules/moment"
//************************************//
interface UncontrolledDateTimeProps {
  value?: any;
  className?: string;
  placeholder?: string;
  size?: string;
  format?: LongDateFormatKey;
  disabled: boolean;
  displayFormat?: LongDateFormatKey;
  startWithDisplayFormat?: string;
  minDate?: string | null;
  maxDate?: string | null;
  enableTime?: boolean;
  allowClear?: boolean;
  timezone?: boolean;
  drops?: string;
  cancelLabel?: string;
  applyLabel?: string;
  onChange?: (date: string | null) => void;
  onInputChange?: (date: string | null) => void;
  onClear?: ({ ref, value }: { ref: any, value: null }) => void;
  refs?: (ref: React.RefObject<any>) => void;
  displayCalenderIcon?: boolean;
  opens?: string
}

const UncontrolledDateTime = React.forwardRef<any, UncontrolledDateTimeProps>((props, currentRef) => {
  //************************************//
  const {
    // value = '',
    className = '',
    placeholder = '',
    size = 'md',
    format = 'L',
    disabled = false,
    // displayFormat = 'L',
    // startWithDisplayFormat = '',
    minDate = null,
    maxDate = null,
    enableTime = false,
    allowClear = false,
    timezone = true,
    drops = "down",
    cancelLabel = 'gen.actions.cancel',
    applyLabel = 'gen.actions.apply',
    onChange = () => { },
    onInputChange = () => { },
    onClear = () => { },
    refs,
    opens = isRtl() ? 'left' : 'right',
    displayCalenderIcon
  } = props
  let {
    value = '',
    displayFormat = 'L',
    startWithDisplayFormat = ''
  } = props
  //************************************//
  const ref = useRef<any>(null)
  const Component = allowClear || displayCalenderIcon ? InputGroup : "div"
  value = value
    ? moment(value).toISOString(timezone)
    : undefined
  startWithDisplayFormat = startWithDisplayFormat ? `${startWithDisplayFormat} ` : ''
  //************************************//
  const clearDate = () => {
    if (disabled) return
    //
    ref.current.$picker.val('')
    // onChange
    if (onChange) onChange(null)
    if (onInputChange) onInputChange(null)
    // onClear
    if (onClear) onClear({ ref: ref.current.$picker, value: null })
  }
  const openCalender = () => {
    if (disabled) return
    //
    if (ref.current && ref.current.$picker) {
      ref.current.$picker.click()
    }
  }
  const handleApply = (event: any, picker: any) => {
    const date = picker.startDate
    if (date) {
      // const dateFormatted = moment(date).utc().toISOString()
      const dateFormatted = moment(date).utc(!timezone).toISOString()
      if (onChange) onChange(dateFormatted)
      if (onInputChange) onInputChange(dateFormatted)
    }
  }
  const handleOnEvent = (event: any, picker: any) => {
    // const container = picker.container
    // container.find('.calendar-time').css('color', 'transparent')
    // container.find('.minuteselect').css('display', 'none')
    // container.find('.calendar-time').off('change').on('change', 'select', () => {
    //   container.find('.minuteselect').css('display', 'none')
    // })
  }
  const getLocaleDateFormat = () => {
    return moment.localeData().longDateFormat(format)
  }
  // todo: Must move to Utils
  const toLocalDateFormat = (date: string, format = 'L', isUtc = true, timezone = false) => {
    const moment_date = isUtc ? moment.utc(date) : moment(date)
    return timezone ? moment_date.local().format(format) : moment_date.format(format)
  }
  //************************************//
  useEffect(() => {
    if (refs) refs(ref)
  }, [ref])
  useEffect(() => {
    if (value !== undefined) {
      displayFormat = displayFormat || format
      // if (value) ref.current.$picker.val(`${startWithDisplayFormat}${toLocalDateFormat(value, displayFormat)}`)
      if (value) ref.current.$picker.val(`${startWithDisplayFormat}${toLocalDateFormat(value, displayFormat, true, timezone)}`)
    }
  }, [value, minDate, maxDate, format, displayFormat, startWithDisplayFormat])
  //************************************//
  return (
    <Component className={'date-time-calender'}>
      <DateRangePicker
        key={`${value} ${minDate} ${maxDate}`}
        ref={ref}
        initialSettings={{
          autoUpdateInput: false,
          singleDatePicker: true,
          timePicker: enableTime,
          showDropdowns: true,
          minYear: 2022,
          startDate: value ? value : undefined,
          minDate: minDate || moment('2022-01-01').utc(true).toISOString(),
          maxDate: maxDate || moment('2038-01-01').utc(true).toISOString(),
          opens,
          locale: {
            format: getLocaleDateFormat(),
            cancelLabel: trans(cancelLabel),
            applyLabel: trans(applyLabel)
          },
          drops
        }}
        onApply={handleApply}
        onEvent={handleOnEvent}
      >
        <input type="text"
          className={classnames(className, { 'form-control': true, 'bg-white': !disabled, [`form-control-${size}`]: size })}
          placeholder={placeholder}
          readOnly={true}
          disabled={disabled}
          style={{ opacity: 1 }}
        />
      </DateRangePicker>
      {allowClear && (
        <InputGroupAddon addonType='append'>
          <InputGroupText className={classnames({ "cursor-pointer": !disabled, "bg-light": disabled })} onClick={clearDate}>
            <FontAwesomeIcon icon={XIcon} style={{ fontSize: 14 }} />
          </InputGroupText>
        </InputGroupAddon>
      )}
      {displayCalenderIcon && (
        <InputGroupAddon addonType='append'>
          <InputGroupText className={classnames({ "cursor-pointer": !disabled, "bg-light": disabled })} onClick={openCalender}>
            <FontAwesomeIcon icon={CalendarCheckIcon} style={{ fontSize: 14 }} />
          </InputGroupText>
        </InputGroupAddon>
      )}

    </Component>
  )
})
// //************************************//
// UncontrolledDateTime.defaultProps = {
//   value: '',
//   className: '',
//   placeholder: '',
//   size: 'md',
//   format: 'L',
//   displayFormat: 'L',
//   startWithDisplayFormat: '',
//   minDate: null,
//   maxDate: null,
//   opens: 'right',
//   enableTime: false,
//   allowClear: false,
//   timezone: true,
//   drops: "down",
//   cancelLabel: 'gen.actions.cancel',
//   applyLabel: 'gen.actions.apply',
//   onChange: (date) => {},
//   onClear: ({ref, value}) => {}
// }
// //************************************//
// UncontrolledDateTime.propTypes = {
//   value: Proptypes.any,
//   className: Proptypes.string,
//   placeholder: Proptypes.string,
//   size: Proptypes.string,
//   format: Proptypes.string,
//   displayFormat: Proptypes.string,
//   startWithDisplayFormat: Proptypes.string,
//   minDate: Proptypes.string,
//   maxDate: Proptypes.string,
//   opens: Proptypes.string,
//   enableTime: Proptypes.bool,
//   allowClear: Proptypes.bool,
//   timezone: Proptypes.bool,
//   drops: Proptypes.string,
//   cancelLabel: Proptypes.string,
//   applyLabel: Proptypes.string,
//   onChange: Proptypes.func,
//   onClear: Proptypes.func
// }
//************************************//
export default UncontrolledDateTime
